"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamsCache = void 0;
const nfl_teams_2022_json_1 = __importDefault(require("../resources/nfl_teams_2022.json"));
const nfl_teams_2023_json_1 = __importDefault(require("../resources/nfl_teams_2023.json"));
const nfl_teams_2024_json_1 = __importDefault(require("../resources/nfl_teams_2024.json"));
const nfl_teams_2025_json_1 = __importDefault(require("../resources/nfl_teams_2025.json"));
/**
 * Represents a cache for storing and retrieving teams data.
 * @public
 */
class TeamsCache {
    /**
     * Creates an instance of the TeamsCache class.
     */
    constructor() {
        const twentyTwentyTwo = nfl_teams_2022_json_1.default.teams.map((team) => ({
            id: team.teamId,
            abbreviation: team.teamAbv,
            name: team.name,
            city: team.city,
            fullName: team.fullName,
            primaryColor: team.colors[0],
            secondaryColor: team.colors[1],
            byeWeek: team.byeWeek,
        }));
        const twentyTwentyThree = nfl_teams_2023_json_1.default.teams.map((team) => ({
            id: team.teamId,
            abbreviation: team.teamAbv,
            name: team.name,
            city: team.city,
            fullName: team.fullName,
            primaryColor: team.colors[0],
            secondaryColor: team.colors[1],
            byeWeek: team.byeWeek,
        }));
        const twentyTwentyFour = nfl_teams_2024_json_1.default.teams.map((team) => ({
            id: team.teamId,
            abbreviation: team.teamAbv,
            name: team.name,
            city: team.city,
            fullName: team.fullName,
            primaryColor: team.colors[0],
            secondaryColor: team.colors[1],
            byeWeek: team.byeWeek,
        }));
        const twentyTwentyFive = nfl_teams_2025_json_1.default.teams.map((team) => ({
            id: team.teamId,
            abbreviation: team.teamAbv,
            name: team.name,
            city: team.city,
            fullName: team.fullName,
            primaryColor: team.colors[0],
            secondaryColor: team.colors[1],
            byeWeek: team.byeWeek,
        }));
        this.teams = { 2022: twentyTwentyTwo, 2023: twentyTwentyThree, 2024: twentyTwentyFour, 2025: twentyTwentyFive };
    }
    /**
     * Retrieves a team by its ID for a specific season.
     * @param teamId - The ID of the team.
     * @param season - The season for which to retrieve the team.
     * @returns The team object if found, otherwise undefined.
     */
    getTeamById(teamId, season) {
        return this.teams[season].find((team) => team.id === teamId);
    }
    /**
     * Retrieves all teams for a specific season.
     * @param season - The season for which to retrieve the teams.
     * @returns An array of team objects for the specified season.
     */
    getTeamsForSeason(season) {
        return this.teams[season];
    }
    /**
     * Checks if teams data for a specific season is cached.
     * @param season - The season to check.
     * @returns True if teams data for the specified season is cached, otherwise false.
     */
    isSeasonCached(season) {
        return !!this.teams[season];
    }
}
exports.TeamsCache = TeamsCache;
//# sourceMappingURL=teams-cache.js.map